import _extends from "../../node_modules/@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { clsx } from "../../../../clsx/dist/clsx.es.js";
import { PickersToolbarText } from "./PickersToolbarText.es.js";
import { getPickersToolbarUtilityClass } from "./pickersToolbarClasses.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import styled from "../../../material/styles/styled.es.js";
import MUIButton from "../../../material/Button/Button.es.js";
import useThemeProps from "../../../material/styles/useThemeProps.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const _excluded = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"];
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
const PickersToolbarButtonRoot = styled(MUIButton, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
});
const PickersToolbarButton = /* @__PURE__ */ React.forwardRef(function PickersToolbarButton2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersToolbarButton"
  });
  const {
    align,
    className,
    selected,
    typographyClassName,
    value,
    variant,
    width
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useUtilityClasses(props);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButtonRoot, _extends({
    variant: "text",
    ref,
    className: clsx(className, classes.root)
  }, width ? {
    sx: {
      width
    }
  } : {}, other, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarText, {
      align,
      className: typographyClassName,
      variant,
      value,
      selected
    })
  }));
});
export {
  PickersToolbarButton
};
//# sourceMappingURL=PickersToolbarButton.es.js.map
